import { Component, ChangeDetectionStrategy } from "@angular/core";
import {
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogClose
} from "@angular/material/dialog";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: "app-delete-device-dialog",
  templateUrl: "./delete-device-dialog.component.html",
  styleUrls: ["./delete-device-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatButton,
    MatDialogClose,
    MatIcon
  ]
})
export class DeleteDeviceDialogComponent {
  constructor(public dialogRef: MatDialogRef<DeleteDeviceDialogComponent>) {}
}
